<script setup>
import { useVModel } from "@vueuse/core";
import { cn } from "@/lib/utils";
import { inputVariants } from ".";

const props = defineProps({
  defaultValue: { type: [String, Number], required: false, default: null },
  modelValue: { type: [String, Number], required: false, default: null },
  class: { type: null, required: false, default: null },
  size: { type: String, required: false, default: "default" },
  isError: { type: Boolean, required: false, default: false },
  isSuccess: { type: Boolean, required: false, default: false },
});

const emits = defineEmits(["update:modelValue"]);

const modelValue = useVModel(props, "modelValue", emits, {
  passive: true,
  defaultValue: props.defaultValue,
});
</script>

<template>
  <input
    v-model="modelValue"
    :class="
      cn(
        inputVariants({ size: props.size }),
        props.class,
        props.isError && 'border-destructive focus-visible:ring-destructive bg-red-50',
        props.isSuccess && 'border-success focus-visible:ring-success bg-green-50'
      )
    "
  />
</template>
